// Signout.js
import React from 'react';
import { useNavigate} from 'react-router-dom'; // Import useHistory hook
//import Cookies from 'js-cookie';
import ProductContext from '../context/ProductContext';
import {useContext} from 'react';

//const username = sessionStorage.getItem('sessionusername');
function Signout({ username=sessionStorage.getItem('sessionusername') }) {
    const productCtx = useContext(ProductContext);
  const {
    setLogin
  } = productCtx;
    const navigate = useNavigate();
   const handleLogout1 = () => {
        // Perform logout actions here (e.g., clear session, remove authentication token)
        // After logout, redirect to the login page
        /* sessionStorage.removeItem("jwtToken");
        setLogin(null); */
        navigate(-1);
    };
    const handleLogout2 = () => {
        // Perform logout actions here (e.g., clear session, remove authentication token)
        // After logout, redirect to the login page
        sessionStorage.removeItem("jwtToken");
        setLogin(null);
        navigate('/')
    };
    /* if(sessionStorage.getItem('jwtToken')==null) {
        return(
            <p className="text-center">You need to be logged in.</p>
        )
    } */
    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="border rounded-lg p-4" style={{width: '500px', height: '400px'}}>
                <h2 className="mb-4 text-center">You are about to leave the website. Please confirm selection.</h2>
                {/* <p className="mb-4 text-center">Hello, {username}!</p>
                <p className="text-center">You are logged in successfully.</p> */}
                <div className="text-center">
                    <button type="button" className="btn btn-primary mt-3" onClick={handleLogout1}>Cancel</button> <nbs/> <nbs/>
                    <button type="button" className="btn btn-primary mt-3" onClick={handleLogout2}>Confirm Logout</button>
                </div>
            </div>
        </div>
    );
}

export default Signout;